module.exports = __webpack_public_path__ + "static/img/750x520.98346bc8.png";